"use client";
import * as React from "react";
const SvgArrowBackwardRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.97 6.97H3.5l5.01-5.01c.4-.4.4-1.06 0-1.46S7.48.1 7.08.5L.3 7.27c-.4.4-.4 1.04 0 1.45l6.77 6.76a1.02 1.02 0 1 0 1.44-1.45l-5-5h11.46A1.03 1.03 0 0 0 16 8a1.03 1.03 0 0 0-1.03-1.03" }));
export {
  SvgArrowBackwardRound as default
};
